import { render, staticRenderFns } from "./OrgModal.vue?vue&type=template&id=173e544f&scoped=true"
import script from "./OrgModal.vue?vue&type=script&lang=js"
export * from "./OrgModal.vue?vue&type=script&lang=js"
import style0 from "./OrgModal.vue?vue&type=style&index=0&id=173e544f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e544f",
  null
  
)

export default component.exports